import image from './apple_iphone_x_space_grey.png';
import { Container, Content, Overlay } from './styles';

export function DevicePreview() {
  return (
  <Container>
    <div className="iphoneX">
      <img src={image} alt="Iphone X Preview" />
      <Overlay>
        <Content>

        </Content>
      </Overlay>
    </div>
  </Container>
)}
